import { Typography } from '@material-ui/core'
import { Avatar, Box, Card, CardActions, CardContent, CardHeader, Dialog, Stack } from '@mui/material'
import './styles.css'
import { DateTime } from 'luxon'
import React, { MouseEventHandler } from 'react'
import { BiDownload, BiQuestionMark, BiX, BiTime } from 'react-icons/bi'
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery'

import { Offense_StatusEnum } from 'src/api/gen'
import { getOffenseStatusColor, getVehicleCategoryIcon } from 'src/commons/constants'
import CopIcon from 'src/commons/icons/CopIcon'
import BaseIconButton from 'src/muiv5/components/commons/BaseIconButton'
import Tag from 'src/muiv5/components/commons/Tag'

import { renderItem } from './utils'

export interface IMdsOffenseProofDialogProps {
  agentName?: string
  date?: string
  downloadLink?: string
  downloadUrl?: string
  images: ReactImageGalleryItem[]
  onCloseClick?: MouseEventHandler<HTMLButtonElement>
  onDownloadClick?: MouseEventHandler<HTMLButtonElement>
  type?: string
  vehicleType?: string
}

export default function MdsOffenseProofDialog({
  agentName,
  type,
  vehicleType,
  date,
  images,
  downloadUrl,
  onCloseClick,
  onDownloadClick,
}: IMdsOffenseProofDialogProps) {
  const VehicleTypeIcon = vehicleType ? getVehicleCategoryIcon(vehicleType) : BiQuestionMark
  const offenseColor = getOffenseStatusColor(type as Offense_StatusEnum)

  return (
    <Dialog maxWidth="md" scroll="paper" open>
      <Card
        sx={{
          minWidth: '500px',
        }}
      >
        <CardHeader
          avatar={
            <Avatar sx={{ color: 'white', fontSize: '20px' }}>
              <VehicleTypeIcon />
            </Avatar>
          }
          action={
            <Stack direction="row" gap={1}>
              <BaseIconButton disabled={!downloadUrl} onClick={onDownloadClick}>
                <BiDownload />
              </BaseIconButton>
              <BaseIconButton onClick={onCloseClick}>
                <BiX />
              </BaseIconButton>
            </Stack>
          }
          title={
            <Stack direction="row" gap={1} sx={{ fontSize: 16, color: 'text.primary' }}>
              <Box>
                <CopIcon />
              </Box>
              <Typography variant="h6">{agentName}</Typography>
            </Stack>
          }
          subheader={
            <Stack direction="column" gap={2} alignItems="flex-start">
              <Stack direction="row" gap={1} sx={{ fontSize: 16, color: 'text.primary' }}>
                <Box>
                  <BiTime />
                </Box>
                <Typography variant="subtitle1">
                  {date ? DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT) : ''}
                </Typography>
              </Stack>
              <Tag color={offenseColor?.text} background={offenseColor?.background} label={type} />
            </Stack>
          }
        />
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent="center" minWidth="300px" minHeight="300px">
            <ImageGallery
              showNav={false}
              showFullscreenButton={false}
              useTranslate3D={false}
              showPlayButton={false}
              showIndex={false}
              showBullets
              items={images}
              lazyLoad={false}
              thumbnailPosition="right"
              renderItem={renderItem}
            />
          </Box>
        </CardContent>
        <CardActions disableSpacing />
      </Card>
    </Dialog>
  )
}
